import { oidcEarlyInit } from "oidc-spa/entrypoint";
const { shouldLoadApp } = oidcEarlyInit({
   freezeFetch: undefined,
   freezeXMLHttpRequest: undefined,
   freezeWebSocket: undefined,
   freezePromise: undefined,
   safeMode: undefined,
   BASE_URL: "/"
});

if (shouldLoadApp) {
    import("./index.tsx?oidc-spa-original=true");
}